import 'jquery-ui-dist/jquery-ui'

// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;

function init_todos() {
	if($('.todos').length === 0) return;
	
	// Destroy existing sortable if it exists
	var $todos = $('.todos');
	if($todos.data('ui-sortable') || $todos.hasClass('ui-sortable')) {
		try {
			$todos.sortable('destroy');
		} catch(e) {
			// Sortable not initialized, ignore error
		}
	}
	
	$('.todos').sortable({
		axis: 'y',
		cursor: 'move',
		opacity: 0.4,
		scroll: true,
		containerSelector: 'ul.todos',
		items: 'li',
		handle: '.handle',
		update: function(){
			$.ajax({
				type: 'post',
				data: $('ul.todos').sortable('serialize'),
				dataType: 'script',
				complete: function(request){
					$('.todos').effect('highlight');
				},
				url: '/todos/sort'
			})
		}
	});
}

// Expose globally for Rails UJS templates
// wait until jQuery is loaded 
// and include turbo:load and turbo:frame-load events	
$(document).on('turbo:load turbo:frame-load', function() {
	if($('.todos').length > 0) {
		window.init_todos = init_todos;
	}
});
